export enum UploaderVariant {
  UserAvatar = 'user-avatar',
  AdminUserAvatar = 'admin-user-avatar',
  TournamentBanner = 'tournament-banner',
  TournamentCard = 'tournament-card',
}
